import { get as call } from "$lib/api";
import {currentCustomer} from "$lib/stores/customer";
import Sleep from "$lib/utils/sleep";

let customerUUID:string;
currentCustomer.subscribe(val => {
    if(val && typeof val.uuid !== 'undefined'){
        customerUUID = val.uuid;
    }
})

export const availableProjectLeaders = async ():Promise<any> => {
    if(typeof customerUUID === 'undefined'){
        await Sleep(1000);

    }
    return await call("/associates/customer/" + customerUUID);
}

export const customerAssociates = async (customerUUID:string):Promise<any> => {
    return await call("/associates/customer/" + customerUUID);
}

export const searchCustomers = async (search:string):Promise<any> => {
    return await call("/customers?order=registry&search=" + search);
}
export const listCustomersPaginated = async (query:string = ''):Promise<any> => {
    return await call("/customers"+(query.length > 0 ? "?"+query : ""));
}

export const fullCustomer = async (customerUUID:string):Promise<any> => {
    return await call("/customer/" + customerUUID);
}

